// Layout: Division landing page
// 

JLM.MD.PageLanding = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let area_contact, form_contact;
	
	// Settings
	let division_type = null;
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		var area_header, but_header_contact, but_header_view, area_video, area_intro, gallery_container, gallery_index, but_gallery_prev, but_gallery_next, area_help, but_help_contact, area_talent, area_about, observer_scroll;
		
		// References
		area_header = $('#area_header', container);
			but_header_contact = $('button[data-action="contact"]', area_header);
			but_header_view = $('button[data-action="view"]', area_header);
		area_video = $('#area_video', container);
		area_intro = $('#area_intro', container);
			gallery_container = $('#talent_gallery', area_intro);
				gallery_index = $('.counter .index', gallery_container);
				but_gallery_prev = $('button[value="prev"]', gallery_container);
				but_gallery_next = $('button[value="next"]', gallery_container);
		area_help = $('#area_help', container);
			but_help_contact = $('button[data-action="contact"]', area_help);
		area_talent = $('#area_talent', container);
		area_about = $('#area_about', container);
		area_contact = $('#area_contact', container);
			form_contact = new JLM.MD.FormContact( $('#jl_contact', area_contact) );
		
		// Settings
		division_type = $('body').data('division');
		
		// Video
		JLM.player = new JLM.MD.MediaPlayerVideo( $('#media-player', area_video) );
		
		// Gallery
		let images = [],
			image_content = JSON.parse( $('meta[name="gallery_images"]', gallery_container).attr('content') );
		image_content.forEach(function(item) {
			images.push({
				href: item['1x'] + '.jpg',
				sources: [
					{
						type: 'image/webp',
						srcset: item['2x'] + '.webp 2x, ' + item['1x'] + '.webp 1x'
					},
					{
						type: 'image/jpeg',
						srcset: item['2x'] + '.jpg 2x, ' + item['1x'] + '.jpg 1x'
					}
				]
			});
		});
		const gallery = blueimp.Gallery(images, {
			container: $('.blueimp-gallery', gallery_container),
			carousel: true,
			startSlideshow: false,
			onslide: function() {
				let index = gallery.getIndex() + 1;
				gallery_index.html(index.zeroPad(2));
			}
		});
		
		// Talent entries
		$('ul.directory > li', area_talent).each(function() {
			let talent_id = $(this).data('id'),
				talent_name = $('.header h3', this).text();
			let item_shortlist = $('li[data-type="shortlist"]', this),
				but_shortlist = $('button', item_shortlist),
				icon_shortlist = $('svg use', but_shortlist),
				but_biography = $('li[data-type="download"] button', this),
				but_showreel = $('li[data-type="media"] button', this);
			
			if ( JLM.database.isInShortlist(talent_id, division_type) ) {
				toggleShortlistButton(item_shortlist, icon_shortlist, false);
			}
			
			but_shortlist.on('click', function() {
				let is_shortlisted = item_shortlist.hasClass('selected');
				toggleShortlistButton(item_shortlist, icon_shortlist, is_shortlisted);
				if ( is_shortlisted ) {
					JLM.menu.removeFromShortlist(talent_id, division_type);
				} else {
					JLM.menu.addToShortlist(talent_id, division_type);
				}
			});
			but_biography.on('click', function() {
				// Track
				JLM.MT.trackEvent('Download', {
					event_category: 'Biography',
					event_label: JSON.stringify({
						talent: talent_id,
						division: division_type
					})
				});
				
				// Download
				let talent_name_url = JLM.MT.generateTalentNameURL( talent_name );
				window.location.href = JLM.MT.generateBioURL( talent_id, talent_name_url, division_type );
			});
			but_showreel.on('click', function() {
				let talent_name_url = JLM.MT.generateTalentNameURL( talent_name );
				if ( division_type == JLM.NS.DIVISION_VOICES ) {
					JLM.MD.MediaPlayer.launchAudioPlayer( talent_id, talent_name_url );
				} else {
					JLM.MD.MediaPlayer.launchVideoPlayer( talent_id, talent_name_url, division_type );
				}
			});
		});
		
		// Observed elements
		let observed_elements = [];
		observed_elements.push( area_header );
		if ( area_video.length ) {
			observed_elements.push( area_video );
		}
		observed_elements.push( area_intro );
		observed_elements.push( area_help );
			observed_elements.push( $('.ctabar', area_help) );
		observed_elements.push( area_talent );
			$('.content .directory > li', area_talent).each(function() {
				observed_elements.push( $(this) );
			});
			observed_elements.push( $('.foot', area_talent) );
		observed_elements.push( area_about );
			observed_elements.push( $('.content .photos', area_about) );
		observed_elements.push( area_contact );
		
		// Observer
		if ( window.IntersectionObserver ) {
			observer_scroll = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function( entry ) {
					const target = $(entry.target);
					if ( entry.isIntersecting ) {
						target.addClass('reveal');
						observer.unobserve(target[0]);
					}
				});
			}, {
				rootMargin: "0px",
				threshold: 0
			});
			observed_elements.forEach(function(element) {
				observer_scroll.observe(element[0]);
			});
		} else {
			observed_elements.forEach(function(element) {
				element.addClass('reveal');
			});
		}
		
		// Events
		but_header_contact.on('click', jumpToContactForm);
		but_header_view.on('click', function() {
			window.location.assign( $(this).data('url') );
		});
		but_gallery_prev.on('click', function() {
			gallery.prev();
		});
		but_gallery_next.on('click', function() {
			gallery.next();
		});
		but_help_contact.on('click', jumpToContactForm);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Jump down the page to Contact form
	// 
	function jumpToContactForm() {
		$([document.documentElement, document.body]).scrollTop( area_contact.offset().top );
		setTimeout(function() {
			form_contact.focus();
		}, 10);
	}
	
	
	// Update shortlist status for talent entry
	// 
	function toggleShortlistButton(item, icon, is_shortlisted) {
		if ( is_shortlisted ) {
			item.removeClass('selected');
			icon.attr('xlink:href', '#jl_icon_shortlist_add');
		} else {
			item.addClass('selected');
			icon.attr('xlink:href', '#jl_icon_shortlist_remove');
		}
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};